import React, { useCallback, useRef, useState } from "react";
import BarcodeReader from "react-barcode-reader";
import { Box, Fab, Typography, Tooltip } from "@mui/material";
import { Iconify } from "../Minimal/src/components/iconify/iconify";

const BarcodeScanner = ({
  onDetected,
  onError,
  debounceInterval = 600,
  label = "Barcode Scanner"
}) => {
  const [enabled, setEnabled] = useState(true);
  const [lastValue, setLastValue] = useState("");
  const lastScanRef = useRef({ value: "", timestamp: 0 });

  const handleScan = useCallback(
    (value) => {
      if (!value) {
        return;
      }
      const trimmedValue = `${value}`.trim();
      if (!trimmedValue) {
        return;
      }
      const now = Date.now();
      if (
        lastScanRef.current.value === trimmedValue &&
        now - lastScanRef.current.timestamp < debounceInterval
      ) {
        return;
      }
      lastScanRef.current = { value: trimmedValue, timestamp: now };
      setLastValue(trimmedValue);
      if (onDetected) {
        onDetected(trimmedValue);
      }
    },
    [onDetected, debounceInterval]
  );

  const handleError = useCallback(
    (error) => {
      if (onError) {
        onError(error);
      }
    },
    [onError]
  );

  const toggleScanner = useCallback(() => {
    setEnabled((prev) => !prev);
  }, []);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {enabled && <BarcodeReader onScan={handleScan} onError={handleError} />}
      {/* <Tooltip title={enabled ? "Scanner On" : "Scanner Off"} placement="top">
        <Fab
          color={enabled ? "success" : "error"}
          onClick={toggleScanner}
          size="small"
        >
          <Iconify icon="material-symbols:barcode-reader-outline-rounded" width={24} />
        </Fab>
      </Tooltip>
      <Box display="flex" flexDirection="column">
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="body2" fontWeight={600}>
          {lastValue || "Awaiting scan"}
        </Typography>
      </Box> */}
    </Box>
  );
};

export default BarcodeScanner;

